import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button, Paper } from '@mui/material';
import { API, graphqlOperation } from "aws-amplify";
import { deleteItemmaster, deleteTransactionMaster } from '../../graphql/mutations';
import { LoadingButton } from "@mui/lab";
import { showSuccessSnackbar } from "../snackBar/snakbar";
import { useNavigate } from "react-router-dom";
import { useThemes } from "../Theme/theme";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 24,
    outline: "none",
    borderRadius: "4px"
};

const DeleteJournalEntry = ({ open, setOpen, itemData, rows, setRows, getJournalEntries }) => {
    const { theme } = useThemes()

    const [loading, setLoading] = useState(false);
    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    }
    let navigate = useNavigate()

    async function deleteEntry(data) {
        try {
            const res = await API.graphql(
                graphqlOperation(deleteTransactionMaster, { TransactionID: data })
            )
            if (res.data?.deleteTransactionMaster != null) {
                // let arr = rows.filter( (item,ind) => {
                //     if(ind!=itemData?.ind) {
                //         return item
                //     }
                // })
                // setRows(arr)
                if (getJournalEntries) {
                    getJournalEntries()
                }
                setOpen(false)
                showSuccessSnackbar("Deleted Journal Entry Successfully ")
                navigate("/journalentries")
            } else {
                alert('Item not Deleted.! something went wrong. please try again')
                setOpen(false)
            }
            setLoading(false)
            // console.log(res);
        } catch (error) {
            setLoading(false)
            console.log(error);
        }

    }

    const deleteItem = () => {
        setLoading(true)
        const ItemID = itemData?.id
        deleteEntry(ItemID)
    }

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {/* <Fade in={open}> */}
            <Paper sx={style}>
                <Box sx={{
                    borderRadius: "4px",
                    padding: "15px",
                    textAlign: "center",
                    overflowY: { xs: 'scroll', sm: 'hidden' },
                    '.MuiTableCell-root': {
                        padding: '10px 10px',
                        fontSize: '13px'
                    },
                }}>

                    <Typography sx={{ color: theme?.palette?.TmId.id.toString().includes("9") ? "#FFF1E6" : "rgb(60 60 60)", fontWeight: "bold" }}>
                        Do you want to delete this Journal Entry?
                    </Typography>

                </Box>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // flexDirection: { xs: 'column', sm: 'row' },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                }}>
                    <Button disabled={loading} onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >No</Button>
                    {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
                    <LoadingButton color="error" sx={{ flex: 1, margin: '5px', fontSize: "12px" }} loading={loading} disableRipple={true} variant="contained" onClick={() => deleteItem()}>
                        Yes
                    </LoadingButton>
                </Box>


            </Paper>
            {/* </Fade> */}
        </Modal>

    );
};

export default DeleteJournalEntry;